// Direct CDN renditions for '/api/media/<id>' photos, delivered with public product payloads
// (catalog pages, product page). Lets the browser skip the /api/media → R2 redirect hop.
const direct = new Map();
export function rememberMedia(data) {
  const map = data && data.media;
  if (!map || typeof map !== 'object') return data;
  for (const [src, entry] of Object.entries(map)) {
    if (typeof src === 'string' && Array.isArray(entry?.variants) && entry.variants.length &&
        entry.variants.every(v => Number.isFinite(v?.width) && typeof v?.url === 'string' && /^https:\/\//.test(v.url))) direct.set(src, entry);
  }
  return data;
}
export const directMedia = src => direct.get(src) || null;
export const forgetMedia = () => direct.clear();
